import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { DoctorsService } from '../shared/doctor-service/doctors.service';
import { AuthService } from '../auth-section/auth-service/auth.service';
import { take } from 'rxjs/operators';

@Component({
  selector: 'app-test',
  templateUrl: './test.component.html',
  styleUrls: ['./test.component.css']
})
export class TestComponent implements OnInit {

  testForm: FormGroup;
  personForm: FormGroup;
  token: any
  id:any
  doctype:any
  members: any;
  clinicId:any
  singleId:any
  test: any;
  clinicName: any;

  constructor(private fb: FormBuilder, private doctorservice:DoctorsService,private authService:AuthService) {
   
  }

  ngOnInit(): void {
    this.authService.authDataSubject.pipe(take(1)).subscribe((auth) => {
      this.token = auth._token;
      this.id = auth._id;
      this.doctype = auth._type;
    });
    this.clinicId = JSON.parse(localStorage.getItem('activeClinic'));
    console.log("clinicId -=-=-=-=-=-=-=-=>>>>>>>>.",this.clinicId);
    this.testForm = new FormGroup({
      testname: new FormControl(null,Validators.required),
      price: new FormControl(null,Validators.required)
    })
    //  this.fb.group({
    //   testname: ['', Validators.required],
    //   price: ['', Validators.required]
    // });
    this.getTest();
    this.getClinic();
  }

  getClinic(){
    this.doctorservice.getAllClinic(this.id, this.token).subscribe((res:any)=>{
      this.clinicName = res.clinics[0].clinicName
      console.log(this.clinicName, "this is clinic from test side")
    })
  }
curtest(data){
  this.testForm = new FormGroup({
    testname: new FormControl(data.testId.name,Validators.required),
    price: new FormControl(data.price,Validators.required)
  })
  console.log("thid is data",data);
  this.singleId = data.testId._id;
  console.log("this is test form",this.testForm);
  
}
  editTest(data:any): void {
    console.log("this is data",data);
    let dt = this.testForm.value;
    let payload = {
      clinicId: this.clinicId,
      testId : this.singleId,
      newPrice : dt.price,
    }
    this.doctorservice.editTest(payload,this.token).subscribe((res:any)=>{
      console.log(res);
    })
  }

  getTest(){
    this.doctorservice.getTest(this.token,this.clinicId).subscribe((res:any)=>{
      this.test = res.tests;  
      console.log(this.test);
    });
  }

  deletTest(data){
    console.log(data);
    this.singleId = data.testId?._id;
    let payload = {
      clinicId: this.clinicId,
      testId :this.singleId
    }
    this.doctorservice.deletTest(payload,this.token).subscribe((res:any)=>{
      console.log(res);
      this.getTest();
    })
  }
}